import { Blocks } from 'lucide-react';

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-2 text-text-primary">
      <Blocks size={22} className="text-accent-management-400" aria-hidden="true" />
      {!compact && <span className="text-h3 font-semibold tracking-tight">Dem</span>}
    </div>
  );
}
